// eslint-disable-next-line no-restricted-imports
import { LegalClientFirstHeadSnapshotFragment } from 'api/generated/graphql';
import { LegalClientFirstHeadSnapshotEntity } from 'api/types/entity';
import { Maybe } from 'types/maybe';

import { parseLegalClientFirstHeadEntity } from './parseLegalClientFirstHeadEntity';

export const parseLegalClientFirstHeadSnapshotEntity = (
  data: Maybe<LegalClientFirstHeadSnapshotFragment>
): LegalClientFirstHeadSnapshotEntity | undefined =>
  data
    ? {
        createdAt: new Date(data.createdAt),
        id: data.id,
        value: parseLegalClientFirstHeadEntity(data.value),
      }
    : undefined;
